<template>
  <div>
    <vue-route-transition id="app" :keepAlive="true"></vue-route-transition>
    <transition name="fade">
        <div id="main_player" ref="main_player" class="player" v-show="isShow" >
            <Player id="AudioPlayer" ref="AudioPlayer" @shrinkPlayer="shrinkPlayer" style="background:#f1f1f1;"></Player>
        </div>
    </transition>
    <div  class="playing" id="main_player_logo" @click="openPlayer" v-show="isPlaying">
        <span class="playing__bar playing__bar1"></span>
        <span class="playing__bar playing__bar2"></span>
        <span class="playing__bar playing__bar3"></span>
    </div>
  </div>
</template>

<script>
import Player from './views/lesson/Player'
export default {
  name: 'App',
  data() {
    return {
        isShow: false,
    }
  },
  beforeMount(){
    if(this.isPC()==true){
      this.$store.dispatch('setIsPC',true)
      //window.location.href='http://www.bracebook.com.cn'
    }else{
      this.$store.dispatch('setIsPC',false)
    }
  },
  mounted(){
      // 创建cnzz统计js
      const script = document.createElement('script')
      script.src = 'https://s22.cnzz.com/z_stat.php?id=1274443165&web_id=1274443165'
      script.language = 'JavaScript'
      document.body.appendChild(script)
  },
  watch: {
    '$route': {
      handler(to, from) {
        setTimeout(() => { //避免首次获取不到window._czc
          if (window._czc) {
            let location = window.location;
            let contentUrl = location.pathname + location.hash;
            let refererUrl = '/';
            // 用于发送某个URL的PV统计请求，
            window._czc.push(['_trackPageview', contentUrl, refererUrl])
            window._czc.push(["_setAutoPageview", false]);
          }
        }, 300)
      },
      immediate: true  // 首次进入页面即执行
    }
  },
  methods:{
    isPC(){
        var userAgentInfo = navigator.userAgent;
        var Agents = ["Android", "iPhone",
                    "SymbianOS", "Windows Phone",
                    "iPad", "iPod"];
        var flag = true;
        for (var v = 0; v < Agents.length; v++) {
            if (userAgentInfo.indexOf(Agents[v]) > 0) {
                flag = false;
                break;
            }
        }
        return flag;
    },
    shrinkPlayer(){
        this.isShow=false
    },
    openPlayer(){
        this.isShow=true
        this.$refs.AudioPlayer.initPlay()
    },
  },
  computed:{
    isPlaying(){
      return this.$store.state.playinfo.isPlaying
    }
  },
  components:{
    Player
  }
}
</script>

<style>
*{margin: 0;padding: 0;}
html,body{min-width:320px;max-width:600px;margin-left:auto;margin-right:auto;position: relative;}
body{background: #f1f1f1;overflow: hidden;}


.playing {
      position:fixed;right:10px;top:120px;z-index:100;
      background: rgba(0, 0, 0, 0.6);
      width: 40px;
      height: 40px;
      border-radius: .3rem;
      display: flex;
      justify-content: space-between;
      align-items: flex-end;
      padding: 8px;
      box-sizing: border-box;
  }

  .playing__bar {
      display: inline-block;
      background: white;
      width:5px;
      height: 100%;
      -webkit-animation: up-and-down 1.3s ease infinite alternate;
              animation: up-and-down 1.3s ease infinite alternate;
  }
  .playing__bar1 {
      height: 60%;
  }
  .playing__bar2 {
      height: 30%;
      -webkit-animation-delay: -2.4s;
              animation-delay: -2.4s;
  }
  .playing__bar3 {
      height: 75%;
      -webkit-animation-delay: -3.7s;
              animation-delay: -3.7s;
  }

  @-webkit-keyframes up-and-down {
      10% {height: 30%;}
      30% {height: 100%;}
      60% {height: 50%;}
      80% {height: 75%;}
      100% {height: 20%;}
  }

  @keyframes up-and-down {
      10% {height: 30%;}
      30% {height: 100%;}
      60% {height: 50%;}
      80% {height: 75%;}
      100% {height: 20%;}
  }

  .player {
        width: 100%;height: 100%;z-index: 1000;position: fixed;
        left: 0;top: 0;background-size: cover;text-align:center;background-color:#f1f1f1;
    }
  .fade-enter-active,.fade-leave-active {
        transition: opacity 1s;
    }
  .fade-enter,.fade-leave-to{
        opacity: 0;
    }
</style>


// WEBPACK FOOTER //
// src/App.vue